import { render } from "./PainelDespedidas.vue?vue&type=template&id=48d6fb44&scoped=true"
import script from "./PainelDespedidas.vue?vue&type=script&lang=js"
export * from "./PainelDespedidas.vue?vue&type=script&lang=js"

import "./PainelDespedidas.vue?vue&type=style&index=0&id=48d6fb44&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48d6fb44"]])

export default __exports__